import { Toast, Notify, Dialog } from 'vant'
import wx from 'weixin-jsapi'
export default {
    methods: {
        push(params) {
            this.$router.push(params)
        },
        replace(params) {
            this.$router.replace(params)
        },
        windowPush(url) {
            window.location.href = url
        },
        windowReplace(url) {
            window.location.replace(url)
        },
        back(num = -1) {
            this.$router.go(num)
        },
        notify(title) {
            Notify(title)
        },
        msg(title) {
            Toast(title)
        },
        alert(title, content) {
            return new Promise((resolve) => {
                Dialog.alert({
                    title: title || '标题',
                    message: content || '弹窗内容'
                }).then(() => {
                    resolve()
                })
            })
        },
        confirm(title, content) {
            return new Promise((resolve, reject) => {
                Dialog.alert({
                    title: title || '标题',
                    message: content || '弹窗内容'
                }).then(() => {
                    resolve()
                }).catch(reject)
            })
        },
        sucMsg(title) {
            Toast.success(title)
        },
        errMsg(title) {
            Toast.fail(title)
        },
        loading(title = '加载中...', overlay = false) {
            Toast.loading({
                duration: 0,
                message: title,
                forbidClick: true,
                overlay
            })
        },
        hideLoading() {
            Toast.clear()
        },
        // 设置背景颜色 - 支持默认颜色和自定义颜色
        setBgColor(bgColor = 'gray') {
            const dom = document.getElementsByTagName('body')[0]
            if (bgColor === 'reset') {
                dom.style.backgroundColor = null
            } else {
                dom.style.backgroundColor = bgColor === 'gray' || !bgColor ? '#f6f6f6' : bgColor
            }
        },
        resetBgColor() {
            this.setBgColor('reset')
        },
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        },
        // 删除左右两端的空格
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, '')
        },
        // 判断是否是微信
        isWeiXin() {
            //  window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
        },
        // 获取地理位置坐标
        getLoacationPos() {
            return new Promise((resolve, reject) => {
                wx.getLocation({
                    type: 'wgs84',
                    success: async(res) => {
                        console.log('getLocation', res)
                        var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                        var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                        resolve({ latitude, longitude })
                    },
                    fail: (err) => {
                        console.log('getLocationerr', err)
                        reject(err)
                    }
                })
            })
        }
    }
}
